import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import BackBtn from "./BackBtn";

function SearchResults(props) {
  const queryString = useParams();
  const [matches, setMatches] = useState([]);
  const fetchSettings = props.data.settings;
  const fetchArticles = props.data.content.articles;

  useEffect(() => {
    let matches = [];
    matches = fetchArticles.filter((articles) => {
      const regex = new RegExp(`${queryString.query}`, "gi");
      return articles.question.match(regex);
    });
    setMatches(matches);
    document.body.className = "search-shrink";
    return () => {
      document.body.className = "";
    };
  }, [queryString]);

  return (
    <div className="searchResults">
      <BackBtn />
      <ul className="breadcrumbs">
        <li>
          <Link to="/">{fetchSettings.site}</Link>
        </li>
        <li>Search results</li>
      </ul>
      <div className="searchResultsHeader">
        <h1>Search results</h1>
        <span>
          {matches.length < 1 ? (
            "No results found"
          ) : (
            <>
              {matches.length} results for "{queryString.query}"
            </>
          )}
        </span>
      </div>
      <div className="searchResultsList">
        <ul>
          {queryString.query?.length < 3 ? (
            "No results found"
          ) : (
            <>
              {matches &&
                matches.map((match) => (
                  <li key={match.id}>
                    <Link
                      id={match.id}
                      to={`/article/${match.url}/${match.id}`}
                    >
                      {match.question}
                    </Link>
                    <p>{match.blurb}</p>
                  </li>
                ))}
            </>
          )}
        </ul>
      </div>
    </div>
  );
}

export default SearchResults;
